<template>
  <div class="vacancy_inner">
    <VacanciesInnerHeader :content="content" />
    <div class="vacancy_inner__wrapper container flex j_sb">
      <div class="vacancy_inner__wrapper--left-col flex column wc-lg" v-if="windowWidth >= 1024">
        <span class="f-18 bold uppercase">{{ $fn.tr("დეტალები") }}</span>
        <div class="vacancy_inner__wrapper--left-col__row flex column" v-if="content.location">
          <span class="f-16 medium">{{ $fn.tr("ლოკაცია") }}:</span>
          <h2 class="f-16 bold">
            {{
              $store.state.main.indx.terms.location.filter(loc =>
                content.location.includes(loc.id)
              )[0].title
            }}
          </h2>
        </div>

        <div class="vacancy_inner__wrapper--left-col__row flex column">
          <span class="f-16 medium">{{ $fn.tr("გამოქვეყნდა") }}:</span>
          <h2 class="f-16 bold">{{ get_days }} {{ $fn.tr("დღის წინ") }}</h2>
        </div>

        <div class="vacancy_inner__wrapper--left-col__row flex column">
          <span class="f-16 medium">{{ $fn.tr("დეპარტამენტი") }}:</span>
          <h2 class="f-16 bold">
            {{
              $store.state.main.indx.terms.vacancy_tags.filter(
                tag => content.vacancy_tags.includes(tag.id) && tag.pid == 0
              )[0].title
            }}
          </h2>
        </div>

        <div class="vacancy_inner__wrapper--left-col__row flex column">
          <span class="f-16 medium">{{ $fn.tr("თანამშრომლობის პირობა") }}:</span>
          <h2 class="f-16 bold">{{ content.info }}</h2>
        </div>

        <div class="vacancy_inner__wrapper--left-col__row flex column">
          <span class="f-16 medium">{{ $fn.tr("დედლაინი") }}:</span>
          <h2 class="f-16 bold">{{ _.get(content, "deadline") }}</h2>
        </div>

        <div class="vacancy_inner__wrapper--left-col__cta button pointer bg-light-purple" v-if="windowWidth >= 1024"
          @click="openVacancyModal">
          <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="11.352"
            height="11.351" viewBox="0 0 11.352 11.351">
            <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2"
              d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
              fill="#fff" />
          </svg>
          <span class="f-14 bold uppercase f-white">{{
            $fn.tr("გამოაგზავნე რეზიუმე")
          }}</span>
        </div>

        <div class="vacancy_inner__wrapper--left-col__share flex column" v-if="windowWidth >= 1024">
          <span class="f-16 regular">{{ $fn.tr("გაუზიარე მეგობარს") }}:</span>
          <div class="vacancy_inner__wrapper--left-col__share_wrapper flex">
            <a target="_blank" class="vacancy_inner__wrapper--left-col__share_wrapper--icon pointer"
              v-for="(icon, index) in share_icons" :key="index" @click.stop="openSharePopup(icon.url)">
              <div v-html="icon.svg"></div>
            </a>
          </div>
        </div>
      </div>
      <div class="vacancy_inner__wrapper--left-col flex column wc-lg" v-if="windowWidth <= 1023">
        <span class="f-18 bold uppercase">{{ $fn.tr("დეტალები") }}</span>
        <div class="vacancy_inner__wrapper--left-col__rows_wrapper_sm">
          <div class="vacancy_inner__wrapper--left-col__row flex column" v-if="content.location">
            <span class="f-16 medium">{{ $fn.tr("ლოკაცია") }}:</span>
            <h2 class="f-16 bold">
              {{
                $store.state.main.indx.terms.location.filter(loc =>
                  content.location.includes(loc.id)
                )[0].title
              }}
            </h2>
          </div>

          <div class="vacancy_inner__wrapper--left-col__row flex column">
            <span class="f-16 medium">{{ $fn.tr("დეპარტამენტი") }}:</span>
            <h2 class="f-16 bold">
              {{
                $store.state.main.indx.terms.vacancy_tags.filter(
                  tag => content.vacancy_tags.includes(tag.id) && tag.pid == 0
                )[0].title
              }}
            </h2>
          </div>

          <div class="vacancy_inner__wrapper--left-col__row flex column">
            <span class="f-16 medium">{{ $fn.tr("თანამშრომლობის პირობა") }}:</span>
            <h2 class="f-16 bold">{{ content.info }}</h2>
          </div>

          <div class="vacancy_inner__wrapper--left-col__row flex column">
            <span class="f-16 medium">{{ $fn.tr("გამოქვეყნდა") }}:</span>
            <h2 class="f-16 bold">{{ get_days }} {{ $fn.tr("დღის წინ") }}</h2>
          </div>

          <div class="vacancy_inner__wrapper--left-col__row flex column">
            <span class="f-16 medium">{{ $fn.tr("დედლაინი") }}:</span>
            <h2 class="f-16 bold">{{ _.get(content, "deadline") }}</h2>
          </div>
        </div>
      </div>

      <div class="vacancy_inner__wrapper--right-col wc-lg flex column">
        <div class="vacancy_inner__wrapper--right-col__position_overview" v-html="content.position_overview"></div>
        <div class="vacancy_inner__wrapper--right-col__cta_wrapper flex a_center j_center" v-if="windowWidth <= 1023">
          <div class="vacancy_inner__wrapper--left-col__cta button pointer bg-light-purple" @click="openVacancyModal">
            <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="11.352"
              height="11.351" viewBox="0 0 11.352 11.351">
              <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2"
                d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                fill="#fff" />
            </svg>
            <span class="f-14 bold uppercase f-white">{{
              $fn.tr("გამოაგზავნე რეზიუმე")
            }}</span>
          </div>
        </div>

        <div v-html="content.content"></div>

        <div class="vacancy_inner__wrapper--left-col__share flex column" v-if="windowWidth <= 1023">
          <span class="f-16 regular">{{ $fn.tr("გაუზიარე მეგობარს") }}:</span>
          <div class="vacancy_inner__wrapper--left-col__share_wrapper flex">
            <a target="_blank" class="vacancy_inner__wrapper--left-col__share_wrapper--icon pointer"
              v-for="(icon, index) in share_icons" :key="index" @click.stop="openSharePopup(icon.url)">
              <div v-html="icon.svg"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VacanciesInnerHeader from "@/components/modules/VacanciesInnerHeader";
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  components: { VacanciesInnerHeader },
  mixins: [resize_handler],
  computed: {
    content() {
      return _.get(
        this.$store.state.main.current_content,
        "primary.data.list[0]"
      );
    },
    get_days() {
      let days = _.get(this.content, "updated_at");
      let _days, calc_final;
      let today = new Date();
      days = days.slice(0, 10);
      _days = new Date(days);
      calc_final = today - _days;
      return Math.ceil(calc_final / (1000 * 3600 * 24));
    },
    share_icons() {
      let socialList = [];
      let socialSvgs = _.get(
        this.$store.state.main.indx,
        "widgets.share_icons"
      );
      let uri = encodeURI(
        window.location.protocol +
        "//" +
        window.location.host +
        "" +
        this.$route.path +
        window.location.search
      );

      if (!socialSvgs) return socialList;
      for (let i in socialSvgs) {
        socialList.push({
          svg: socialSvgs[i].svg,
          url: socialSvgs[i].url + uri
        });
      }

      return socialList;
    }
  },
  mounted() { },
  methods: {
    openSharePopup(url) {
      let winWidth = 650;
      let winHeight = 350;
      let winTop = 200;
      let winLeft = screen.width / 2 - winWidth / 2;
      window.open(
        url,
        "sharer",
        "top=" +
        winTop +
        ",left=" +
        winLeft +
        ",toolbar=0,status=0,width=" +
        winWidth +
        ",height=" +
        winHeight
      );
    },
    openVacancyModal(){
      this.$store.state.main.vacancy_modal = !this.$store.state.main.vacancy_modal;
      this.$store.state.main.vacancy_name = this.content.title;
    }
  }
};
</script> 

<style lang="scss" scoped>
.vacancy_inner__wrapper--right-col {
  &::v-deep {

    p,
    span,
    h2,
    h3,
    h4,
    h5,
    h6,
    ul,
    li {
      font-family: "TBCSailec-Medium";

      font-size: 16px;
      line-height: 24px;
    }

    ul {
      list-style-type: none;
      padding-left: 65px;

      @media (max-width: 767px) {
        padding-left: 52px;
      }

      @media (max-width: 413px) {
        padding-left: 32px;
      }
    }

    li {
      position: relative;

      &:after {
        position: absolute;
        left: 0;
        top: 9px;

        content: "";

        font-weight: bold;
        display: inline-block;
        width: 8px;
        height: 8px;
        margin-left: -22px;

        background-color: #7063e9;
        border-radius: 50%;
      }
    }

    strong {
      font-family: "TBCSailec-Bold";

      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
